import { computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, startWith } from 'rxjs';

export function createViewportSignal() {
  const resize$ = fromEvent(window, 'resize').pipe(startWith(null));

  const viewport = toSignal(resize$, { initialValue: null });

  const height = computed(() => {
    viewport();
    return window.innerHeight;
  });

  const width = computed(() => {
    viewport();
    return window.innerWidth;
  });

  return { height, width };
}
